"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var _Button = _interopRequireDefault(require("angieslist-react-components/lib/Button"));

var _Grid = _interopRequireDefault(require("angieslist-react-components/lib/Grid"));

var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));

var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));

var _angieslistAppPlatform = require("angieslist-app-platform");

var _FooterSiteMap = _interopRequireDefault(require("./footer/FooterSiteMap"));

var _FooterSocialIcons = _interopRequireDefault(require("./footer/FooterSocialIcons"));

var _FooterCopyright = _interopRequireDefault(require("./footer/FooterCopyright"));

var _footerConfig = _interopRequireDefault(require("./footer/footerConfig"));

var _footerAnalytics = _interopRequireDefault(require("./footer/footerAnalytics"));

require("./footer/FooterSocialIcons.scss");

var _div, _div2, _img, _img2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var androidIcon = require('./app-store-android.png');

var iosIcon = require('./app-store-apple.png');

var OfficeFooter = function OfficeFooter(_ref) {
  var _ref$isAuthenticated = _ref.isAuthenticated,
      isAuthenticated = _ref$isAuthenticated === void 0 ? false : _ref$isAuthenticated,
      isAdvertiser = _ref.isAdvertiser,
      spId = _ref.spId,
      footerProps = _ref.footerProps,
      isAngiLeads = _ref.isAngiLeads,
      isUnifiedHeader = _ref.isUnifiedHeader,
      businessCenterPhone = _ref.businessCenterPhone,
      isInboxEnabled = _ref.isInboxEnabled,
      isOnBusinessContextPage = _ref.isOnBusinessContextPage;

  var _getFooterConfig$foot = _objectSpread(_objectSpread({}, (0, _footerConfig["default"])({
    isAuth: isAuthenticated,
    isAdvertiser: isAdvertiser,
    spId: spId,
    isAngiLeads: isAngiLeads,
    isUnifiedHeader: isUnifiedHeader,
    businessCenterPhone: businessCenterPhone,
    isInboxEnabled: isInboxEnabled,
    isOnBusinessContextPage: isOnBusinessContextPage
  })), footerProps),
      sitemap = _getFooterConfig$foot.sitemap,
      socialIcons = _getFooterConfig$foot.socialIcons,
      copyrightLinks = _getFooterConfig$foot.copyrightLinks,
      logo = _getFooterConfig$foot.logo;

  function iOSAppUrl(referrer) {
    return isAngiLeads ? _urlCatalog["default"].apps.office.angiLeadsiOS() : _urlCatalog["default"].apps.office.angiAdsiOS(referrer);
  }

  function androidAppUrl(referrer) {
    return isAngiLeads ? _urlCatalog["default"].apps.office.angiLeadsAndroid() : _urlCatalog["default"].apps.office.angiAdsAndroid(referrer);
  }

  return /*#__PURE__*/_react["default"].createElement("div", null, isAuthenticated ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "footer_container"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, isOnBusinessContextPage && /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12,
    sm: 3,
    className: "footer-container-row"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    bsStyle: "link",
    bsSize: "small",
    id: "footer--download-app",
    href: isAngiLeads ? '/app/h/download-app' : '/app/download-app'
  }, _div || (_div = /*#__PURE__*/_react["default"].createElement("div", {
    className: "download-link"
  }, "Download the app")))), _div2 || (_div2 = /*#__PURE__*/_react["default"].createElement("div", {
    className: "download-description"
  }, "Manage your leads from anywhere, anytime.")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mobile-icons"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mobile-icon-div"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    href: iOSAppUrl('OfficeMobileFooter'),
    id: "footer--link-ios",
    target: "blank",
    className: "mobile-app-icon-link"
  }, _img || (_img = /*#__PURE__*/_react["default"].createElement("img", {
    alt: "Download the Angi Pro Ads App for iOS",
    src: iosIcon,
    className: "mobile-app-icon-img"
  }))))), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    href: androidAppUrl('OfficeMobileFooter'),
    id: "footer--link-android",
    target: "blank",
    className: "mobile-app-icon-link"
  }, _img2 || (_img2 = /*#__PURE__*/_react["default"].createElement("img", {
    alt: "Download the Angi Pro Ads App for Android",
    src: androidIcon,
    className: "mobile-app-icon-img"
  })))))), /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12,
    sm: 8,
    smOffset: isOnBusinessContextPage ? '1' : '4'
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_FooterSiteMap["default"], {
    sitemap: sitemap,
    minColumnCount: 3,
    align: "right"
  })))), /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    className: "footer-social-icons-row"
  }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    className: "footer-social-icons-col"
  }, /*#__PURE__*/_react["default"].createElement(_FooterSocialIcons["default"], {
    icons: socialIcons,
    idSuffix: "mobile"
  })))) : undefined, /*#__PURE__*/_react["default"].createElement("div", {
    className: isAuthenticated ? 'auth-footer-copyright' : 'unauth-footer-copyright'
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], null, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12,
    className: "copy-right-links"
  }, /*#__PURE__*/_react["default"].createElement(_FooterCopyright["default"], {
    logo: logo,
    links: copyrightLinks,
    spId: spId,
    isAngiLeads: isAngiLeads
  }))))));
};

var _default = (0, _angieslistAppPlatform.analytics)({
  ruleset: _footerAnalytics["default"]
})(OfficeFooter);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/officeFooter.js
// module id = 3366
// module chunks = 25